import { createFileRoute, redirect } from "@tanstack/react-router";

/** Catálogo operativo unificado en Inventario. */
export const Route = createFileRoute("/app/catalogo")({
  beforeLoad: () => {
    throw redirect({ to: "/app/inventario", search: { tab: "hub" } });
  },
});
